import { useContext, useEffect } from "react";
import { MapContext } from "../../MapContext";
import { registerOlInteraction } from "../helpers";

import { DragRotate } from "ol/interaction";

export default function DragRotateInteraction(props) {
  const context = useContext(MapContext);

  const options = {
    condition: undefined,
    duration: undefined
  };

  const events = {
    change: undefined,
    "change:active": undefined,
    error: undefined,
    propertychange: undefined
  };

  useEffect(
    () =>
      registerOlInteraction(context, DragRotate, props, options, events),
    []
  );

  return null;
}
